import React from 'react';
import PropTypes from 'prop-types';

// material

// ----------------------------------------------------------------------

ErrorMessage.propTypes = {
    errorMessage: PropTypes.string.isRequired,
};

export default function ErrorMessage({ errorMessage }) {

  return (
    <div id="errorMessage">
        <section>
            <div class="alert alert-danger ">
                <div class="alert-body">
                    {errorMessage}
                </div>
            </div>
        </section>
    </div>
  );
}